
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pages]",
      function () {
        return require("private-next-pages/[...pages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pages]"])
      });
    }
  